export default __webpack_public_path__ + "static/media/16.54d685c0.jpg";